import { UserWithToken } from 'shared/types/user'

import { useLoadFeatureFlags } from './hooks/useLoadFeatureFlags'

type FeatureFlagsLoaderProps = {
  user: UserWithToken | null
}

/**
 * Must render inside QueryClientProvider: the flags fetch uses useQuery.
 */
export const FeatureFlagsLoader = ({ user }: FeatureFlagsLoaderProps): null => {
  useLoadFeatureFlags(user)
  return null
}
